/* eslint-disable react/prop-types */
import { useState, useEffect, useContext, useCallback } from "react";
import { url, port } from "../../../../../../../../../config/config";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../../../../../contexts";
import { GetHistoryEnrollmentsQuery } from "../../../../../../../../../utils/api/enrollment/enrollment";
import DependentHistoryProfileInformationGrid from "./dependentAllHistoryGrid/DependentHistoryProfileInformationGrid";
import DependentHistoryContactInformationGrid from "./dependentAllHistoryGrid/DependentHistoryContactInformationGrid";
import { DependentHistoryDetailsProps } from "../../../../../../../../../@types/member.types";
import DependentHistoryBenefitInfoGrid from "./dependentAllHistoryGrid/DependentHistoryBenefitInfoGrid";
import { Benefit, BenefitGrid } from "../../../../../../../../../@types/enrollment.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../utils/api";
import DependentHistoryVEBBenefitGrid from "./dependentAllHistoryGrid/DependentHistoryVEBBenefitGrid";
import DependentHistoryBenefitGrid from "./dependentAllHistoryGrid/DependetHistoryBenefitGrid";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import { GROUP_NUMBER } from "../../../../../../../../../constants/groups";
import CircularLoader from "../../../../../../../../shared/loader/CircularLoader";

const DependentHistoryDetails = ({
	historyDependentProfileInformation,
	historyDependentContactInformation,
	dependent
}: DependentHistoryDetailsProps): JSX.Element => {
	const [dependentHistoryCoreBenefits, setDependentHistoryCoreBenefits] = useState<any[]>([]);
	const [dependentHistoryVEBBenefits, setDependentHistoryVEBBenefits] = useState<any[]>([]);
	const [dependentHistoryVEBBenefitsLoader, setDependentHistoryVEBBenefitsLoader] = useState(true);
	const [dependentHistoryCoreBenefitsLoader, setDependentHistoryCoreBenefitsLoader] = useState(true);
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");

	const getDependentVEBHistoryBenefits = useCallback(async () => {
		setDependentHistoryVEBBenefitsLoader(true);
		try {
			const dependentHistoryVEBBenefitsQuery: any = {
				group_number: dependent.group_number,
				insured_SSN: dependent.employee_SSN,
				member_SSN: dependent.SSN,
				benefit_type: "VEB"
			};
			const response = await api.enrollments.getHistoryBenefitsV2(dependentHistoryVEBBenefitsQuery);

			if (response) {
				const { historyBenefitsAggregatedInstance, historyBenefitLength } = response;

				const _dependentHistoryVEBBenefits: any[] = [];

				for (let idx = 0; idx < historyBenefitsAggregatedInstance.length; idx++) {
					const eachDependentVEBBenefits = historyBenefitsAggregatedInstance[idx];

					const {
						group_number,
						base_plan_name,
						plan_name,
						sub_plan,
						plan_code,
						enrollment_status,
						effective_date,
						enrollment_date,
						enrollment_count,
						enrollments,
						total_premium,
						group_owner,
						group_owner_updated_on,
						agent,
						updatedAt,
						createdAt
					} = eachDependentVEBBenefits;

					const _benefit_end_date = enrollments[0].termination_date;
					const _benefit_end_reason = enrollments[0].termination_reason;

					_dependentHistoryVEBBenefits.push({
						base_plan_name: base_plan_name,
						plan_name: plan_name,
						sub_plan: sub_plan ? sub_plan : "N/A",
						plan_code: plan_code,
						benefit_end_date: _benefit_end_date,
						benefit_end_reason: _benefit_end_reason ? _benefit_end_reason : "N/A",
						total_premium_amount: total_premium,
						coverage_count: enrollment_count,
						effective_date: effective_date,
						enrollment_date: enrollment_date,
						group_owner_updated_on: group_owner_updated_on,
						enrollment_status: "Closed",
						group_number: group_number,
						updatedAt: updatedAt,
						createdAt: createdAt,
						plan_approved_by: group_owner ? group_owner.first_name + " " + group_owner.last_name : "N/A",
						agent_created_by: agent ? agent.first_name + " " + agent.last_name : "N/A"
					});
				}

				setDependentHistoryVEBBenefits(Object.assign([], _dependentHistoryVEBBenefits));
			}
		} catch (error) {
			console.log("Error fetching DependentHistoryVEBBenefits", error);
		} finally {
			setDependentHistoryVEBBenefitsLoader(false);
		}
	}, [dependent.SSN, dependent.employee_SSN, dependent.group_number]);

	const getDependentCoreHistoryBenefits = useCallback(async () => {
		setDependentHistoryCoreBenefitsLoader(true);
		try {
			const dependentHistoryVEBBenefitsQuery: any = {
				group_number: dependent.group_number,
				insured_SSN: dependent.employee_SSN,
				member_SSN: dependent.SSN,
				benefit_type: "CORE"
			};
			const response = await api.enrollments.getHistoryBenefitsV2(dependentHistoryVEBBenefitsQuery);

			if (response) {
				const { historyBenefitsAggregatedInstance, historyBenefitLength } = response;

				const _dependentHistoryCoreBenefits: any[] = [];

				for (let idx = 0; idx < historyBenefitsAggregatedInstance.length; idx++) {
					const eachDependentCoreBenefits = historyBenefitsAggregatedInstance[idx];

					const {
						group_number,
						base_plan_name,
						plan_name,
						sub_plan,
						plan_code,
						enrollment_status,
						effective_date,
						enrollment_date,
						enrollment_count,
						enrollments,
						total_premium,
						group_owner,
						group_owner_updated_on,
						agent,
						updatedAt,
						createdAt
					} = eachDependentCoreBenefits;

					const _benefit_end_date = enrollments[0].termination_date;
					const _benefit_end_reason = enrollments[0].termination_reason;

					_dependentHistoryCoreBenefits.push({
						base_plan_name: base_plan_name,
						plan_name: plan_name,
						sub_plan: sub_plan ? sub_plan : "N/A",
						plan_code: plan_code,
						benefit_end_date: _benefit_end_date,
						benefit_end_reason: _benefit_end_reason ? _benefit_end_reason : "N/A",
						total_premium_amount: total_premium,
						coverage_count: enrollment_count,
						effective_date: effective_date,
						enrollment_date: enrollment_date,
						group_owner_updated_on: group_owner_updated_on,
						enrollment_status: "Closed",
						group_number: group_number,
						updatedAt: updatedAt,
						createdAt: createdAt,
						plan_approved_by: group_owner ? group_owner.first_name + " " + group_owner.last_name : "N/A",
						agent_created_by: agent ? agent.first_name + " " + agent.last_name : "N/A"
					});
				}

				setDependentHistoryCoreBenefits(Object.assign([], _dependentHistoryCoreBenefits));
			}
		} catch (error) {
			console.log("Error fetching DependentHistoryCoreBenefits", error);
		} finally {
			setDependentHistoryCoreBenefitsLoader(false);
		}
	}, [dependent.SSN, dependent.employee_SSN, dependent.group_number]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_history);
	}, [setDashboardHeader]);

	useEffect(() => {
		getDependentCoreHistoryBenefits();
		getDependentVEBHistoryBenefits();
	}, [getDependentCoreHistoryBenefits, getDependentVEBHistoryBenefits]);

	return (
		<>
			{(dependentHistoryCoreBenefitsLoader || dependentHistoryVEBBenefitsLoader) && (
				<div
					style={{
						position: "fixed",
						inset: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999,
						backgroundColor: "rgba(255, 255, 255, 0.5)"
					}}
				>
					<CircularLoader />
				</div>
			)}
			<div className="dependent-history-details-container">
				<div className="pf-title">Profile Information</div>
				<DependentHistoryProfileInformationGrid gridData={historyDependentProfileInformation} />
				<div className="pf-title">Contact Information</div>
				<DependentHistoryContactInformationGrid gridData={historyDependentContactInformation} />
				<div className="pf-title">Core Benefit Information</div>
				<DependentHistoryBenefitGrid historyBenefits={dependentHistoryCoreBenefits} />
				{/* <div className="pf-title">VEB Benefit Information</div>
			<DependentHistoryVEBBenefitGrid historyVEBBenefits={dependentHistoryVEBBenefits} /> */}
				{queryGroupNumber !== GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? (
					<>
						<div className="pf-title">VEB Benefit Information</div>
						<DependentHistoryVEBBenefitGrid historyVEBBenefits={dependentHistoryVEBBenefits} />
					</>
				) : null}
			</div>
		</>
	);
};

export default DependentHistoryDetails;
